import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import * as ReactRouter from 'react-router-dom';
import PropTypes from 'prop-types';
import lock from '../../../components/Auth/lock';
import { parseQueryParams } from '../../../utils/queryStringUtils';
import {
  homeRoute,
  superAdminHomeRoute,
  toolingLocationRoute,
  // solicitationsSearchRoute,
} from '../../../config/navigation/routes';
import { checkIfAuthIsValid } from '../../../utils/authUtils';

class IntermediateLogin extends Component {
  static propTypes = {
    login: PropTypes.func.isRequired,
    auth: PropTypes.shape({
      id: PropTypes.string,
      role: PropTypes.string,
      expiration: PropTypes.number,
      organizationId: PropTypes.string,
    }).isRequired,
    history: PropTypes.object.isRequired,
  };

  componentDidMount() {
    lock.show();
  }

  render() {
    const { login, auth, history } = this.props;
    const self = this;

    const parsedQueryParams = parseQueryParams(history.location.search);
    // The folling logic redirects the user based on role the corresponding route
    let redirectRoute;
    if (auth.role === 'SUPER_ADMIN') {
      redirectRoute = superAdminHomeRoute;
    } else if (auth.role === 'GOVERNMENT_USER') {
      redirectRoute = toolingLocationRoute;
    }
    //eslint-disable-line

    const targetUrl = parsedQueryParams.redirect
      ? parsedQueryParams.redirect
      : redirectRoute;
    lock.authorizedPromise.then(jwtToken => {
      login(jwtToken);
    });
    lock.on('hide', () => {
      if (!checkIfAuthIsValid(self.props.auth)) {
        history.push('location', homeRoute);
      }
    });

    return (
      <div className="nf-intermediate-login">
        <Helmet>
          <meta charSet="utf-8" />
          <title>NFFS ICON - Login Page</title>
        </Helmet>
        {checkIfAuthIsValid(auth) && <ReactRouter.Redirect to={targetUrl} />}
      </div>
    );
  }
}

export default IntermediateLogin;



// WEBPACK FOOTER //
// ./src/pages/static/IntermediateLogin/IntermediateLogin.jsx